import { DateTime_fromTransferable, DateTime_toTransferable, Duration_fromTransferable, Duration_toTransferable, } from "./DateTime";
import { SinglePointCoordinate } from "./SinglePointCoordinate";
import { Area } from "./Area";
export function PointRequest_toTransferable(req) {
    return {
        ...req,
        coordinates: req.coordinates.map((coords) => coords.toTransferable()),
        startDatetime: DateTime_toTransferable(req.startDatetime),
        duration: req.duration ? Duration_toTransferable(req.duration) : undefined,
        temporalResolution: req.temporalResolution ? Duration_toTransferable(req.temporalResolution) : undefined,
        boundingBoxLimit: req.boundingBoxLimit ? req.boundingBoxLimit.toTransferable() : null,
    };
}
export function PointRequest_fromTransferable(req) {
    return {
        ...req,
        coordinates: req.coordinates.map((coords) => SinglePointCoordinate.fromTransferable({
            lng: coords.lng,
            lat: coords.lat,
            crs: coords.crs,
        })),
        startDatetime: DateTime_fromTransferable(req.startDatetime),
        duration: req.duration ? Duration_fromTransferable(req.duration) : undefined,
        temporalResolution: req.temporalResolution ? Duration_fromTransferable(req.temporalResolution) : undefined,
        boundingBoxLimit: req.boundingBoxLimit ? Area.fromTransferable(req.boundingBoxLimit) : null,
    };
}
//# sourceMappingURL=PointRequest.js.map